import { Route } from 'react-router-dom';

import { CityListPage } from './pages/city-pages.js';
import { CountryListPage } from './pages/country-pages.js';
import { CurrencyListPage } from './pages/currency-pages.js';
import { StateListPage } from './pages/state-pages.js';

/**
 * The reference module's routes.
 *
 * List-only for now: the detail and form pages follow the same pattern as
 * properties and tenants, and the import dialog is the primary write path.
 */
export function referenceRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/currencies" element={<CurrencyListPage />} />
      <Route path="/countries" element={<CountryListPage />} />
      <Route path="/states" element={<StateListPage />} />
      <Route path="/cities" element={<CityListPage />} />
    </>
  );
}
